import dynamic from "next/dynamic"
import { AnimatePresence } from "motion/react"

import { selectAudioGuideState } from "@/lib/storage/audio-guide-slice"
import { useAppSelector } from "@/lib/storage/hooks"

const LazyAudioGuidePlayer = dynamic(
  () =>
    import("@/components/audio-guide-player").then(
      (mod) => mod.AudioGuidePlayer
    ),
  { ssr: false }
)

export function AudioGuidePlayerHost() {
  const { status } = useAppSelector(selectAudioGuideState)
  const visible = status !== "idle"

  return (
    <AnimatePresence>
      {visible ? <LazyAudioGuidePlayer key="audio-guide-player" /> : null}
    </AnimatePresence>
  )
}
